import { useEffect, useState } from "react";
import { api, fileUrl } from "@/lib/api";

// Shared branding (logo/favicon) fetched once from public site settings, cached module-level.
let cache = null;
let promise = null;
const subs = new Set();

function fetchBranding() {
  if (!promise) {
    promise = api
      .get("/public/site")
      .then((r) => { cache = { logo_url: r.data.logo_url || "", favicon_url: r.data.favicon_url || "" }; })
      .catch(() => { cache = { logo_url: "", favicon_url: "" }; })
      .finally(() => subs.forEach((fn) => fn(cache)));
  }
  return promise;
}

export function useBranding() {
  const [b, setB] = useState(cache);
  useEffect(() => {
    if (cache) { setB(cache); return undefined; }
    subs.add(setB);
    fetchBranding();
    return () => subs.delete(setB);
  }, []);
  return b || { logo_url: "", favicon_url: "" };
}

export function Logo({ dark = false, className = "h-8", suffix = null }) {
  const { logo_url } = useBranding();
  const src = logo_url ? fileUrl(logo_url) : "/logo-gim.png";
  return (
    <span className="inline-flex items-center gap-3" data-testid="gim-logo">
      <img src={src} alt="Grace Immanuel Ministries" className={`${className} w-auto`}
        style={dark ? { filter: "invert(1) brightness(2)" } : undefined} />
      {suffix && <span className={`font-semibold text-sm ${dark ? "text-white/40" : "text-slate-400"}`}>{suffix}</span>}
    </span>
  );
}

// Injects the custom favicon (if admin uploaded one) at runtime.
export function FaviconManager() {
  const { favicon_url } = useBranding();
  useEffect(() => {
    if (!favicon_url) return;
    const href = fileUrl(favicon_url);
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = href;
    const apple = document.querySelector("link[rel='apple-touch-icon']");
    if (apple) apple.href = href;
  }, [favicon_url]);
  return null;
}

export default Logo;
